import { mlyApi, getHeaders } from "config/mlyApi";

export async function getTags() {
  const requestConfig = await getHeaders();
  const url = `/tags`;
  return mlyApi.get<any>(url, requestConfig);
}
